import React, { useState, useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Snackbar from './components/Snackbar'; 
import { useNotification } from '../context/NotificationContext';
import goldmedalicon from './images/goldmedalicon.png';
import speeddeliveryicon from './images/speeddeliveryicon.png'
import ArrowLeft from './images/ArrowLeft.png';
import { faImage  } from "@fortawesome/free-solid-svg-icons";
import defaultimg from './images/defaultimg.png';


// Skeleton Loader Component
const OrdersSkeleton = () => (
  <div className="animate-pulse p-4">
    {/* Navigation Skeleton */}
    <div className="h-12 bg-gray-200 rounded mb-4"></div>

    {/* Tabs Skeleton */}
    <div className="flex justify-between mb-4">
      {[1, 2, 3, 4].map((tab) => (
        <div key={tab} className="h-8 bg-gray-200 rounded w-1/4"></div>
      ))}
    </div>

    {/* Order Card Skeletons */}
    {[1, 2, 3].map((card) => (
      <div key={card} className="bg-white rounded-lg shadow-sm mb-4 p-4">
        <div className="flex justify-between mb-2">
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
        </div>
        
        <div className="flex items-center space-x-4 mb-2">
          <div className="w-16 h-16 bg-gray-300 rounded-lg"></div>
          <div className="flex-1">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
        
        <div className="flex justify-between">
          <div className="h-4 bg-gray-200 rounded w-1/3"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
        </div>
      </div>
    ))}
  </div>
);

// Create a separate component for the order card with countdown
const OrderCard = ({ order, navigate }) => {
// const DefaultProductImage = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAiIGhlaWdodD0iMjUwIiB2aWV3Qm94PSIwIDAgMjUwIDI1MCI+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjI1MCIgaGVpZ2h0PSIyNTAiIGZpbGw9IiNGMEYwRjAiLz4KICA8dGV4dCB4PSIxMjUiIHk9IjEyNSIgZm9udC1zaXplPSIyMCIgZmlsbD0iIzg4OCIgdGV4dC1hbmNob3I9Im1pZGRsZSI+Tm8gSW1hZ2U8L3RleHQ+Cjwvc3ZnPg=='

  //console.log('Order:', order);
  const [countdown, setCountdown] = useState('');
  const [isExpired, setIsExpired] = useState(false);

 useEffect(() => {
  const calculateCountdown = () => {
    // Use quotation_date or createdAt from the order
    const orderTime = new Date(order.quotation_date || order.createdAt).getTime();
    const currentTime = new Date().getTime();
    const timeDiff = currentTime - orderTime;
    
    // Use order_waiting_time (in minutes) from the order data, fallback to 30 minutes
    const waitingTimeInMinutes = order.order_waiting_time || 30;
    const waitingTimeInMilliseconds = waitingTimeInMinutes * 60 * 1000;
    
    if (timeDiff > waitingTimeInMilliseconds) {
      setIsExpired(true);
      setCountdown('');
      return;
    }

    // Remaining time
    const remainingTime = waitingTimeInMilliseconds - timeDiff;
    
    // Convert to minutes and seconds
    const minutes = Math.floor(remainingTime / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    
    // Format the countdown
    setCountdown(`${minutes}m ${seconds}sec`);
  };

  // Initial calculation
  calculateCountdown();

  // Set up an interval to update countdown every second
  const countdownInterval = setInterval(calculateCountdown, 1000);

  // Clean up interval
  return () => clearInterval(countdownInterval);
}, [order.quotation_date || order.createdAt, order.order_waiting_time]); // Added order_waiting_time to dependencies


  // Helper function to get display status
  const getDisplayStatus = (vendor_status, fulfillmentStatus) => {
    if (vendor_status.toLowerCase() === 'awarded') {
      switch (fulfillmentStatus) {
        case 'Items Ready':
          return 'Items Ready';
        case 'Order Items Picked Up':
          return 'Shipped';
          case 'Delivery Partner Assigned':
            return 'Delivery Partner Assigned';
        case 'Not Started':
        case 'In Progress':
          return 'Awarded';
        default:
          return 'Awarded';
      }
    }
    return vendor_status.charAt(0).toUpperCase() + vendor_status.slice(1);
  };

  // Helper function to get status color
  const getStatusColor = (vendor_status, fulfillmentStatus) => {
    if (vendor_status.toLowerCase() === 'awarded') {
      return 'bg-[#E7FAD5] text-[#524D4D]';
    }
    
    switch (vendor_status.toLowerCase()) {
      case 'respond now':
        return 'bg-[#FFECEA] text-[#524D4D]';
      case 'accepted':
        return 'bg-[#E7FAD5] text-[#524D4D]';
      case 'counter offer':
        return 'bg-[#FDE7FF] text-[#524D4D]';
      case 'skipped':
        return 'bg-[#E7FAD5] text-[#524D4D]';
      default:
        return 'bg-red-100 text-red-800';
    }
  };

  return (
    <div key={order.id} className="border rounded-lg  hover:shadow-md transition-shadow">
      <div onClick={() => navigate(`/supplier/orderdetails`, { 
            state: { quotationId: order._id , 
                     vendor_id : order.vendor_id,
                     from: 'orders' } 
          })} 
      className="p-4 flex flex-col justify-between">
        <div className='flex flex-row justify-between items-center'>
          <div className='flex flex-row justify-between items-center'>
            <p className="text-md font-semibold text-[#524D4D]">{order.orderNumber}</p>
           <span
  className={`ml-3 text-xs px-2 py-1 rounded-full flex items-center gap-1 font-semibold text-[#524D4D] ${
    getDisplayStatus(order.vendor_status, order.in_fulfillment_status) === 'Awarded'
      ? 'bg-[#FFF5C5]'
      : getDisplayStatus(order.vendor_status, order.in_fulfillment_status) === 'Shipped'
      ? 'bg-[#EFFAFF]'
      : getStatusColor(order.vendor_status, order.in_fulfillment_status)
  }`}
>
  {getDisplayStatus(order.vendor_status, order.in_fulfillment_status) === 'Awarded' && (
    <img src={goldmedalicon} alt="Awarded" className="w-4 h-4" />
  )}
  {getDisplayStatus(order.vendor_status, order.in_fulfillment_status) === 'Shipped' && (
    <img src={speeddeliveryicon} alt="Shipped" className="w-4 h-4" />
  )}
  {getDisplayStatus(order.vendor_status, order.in_fulfillment_status)}
</span>


            </div>
                     <p className="text-black text-md font-semibold">{order.total}</p>
          </div>

               <div className='flex flex-row justify-between items-center'>
          
        {(order.status.toLowerCase() === 'respond now') && !isExpired && countdown ? (
  <div className="mt-1 text-red-500 font-medium text-sm">
    <span className='text-[#524D4D]'>Closes in: </span>{countdown}
  </div>
) : (
  <div className="mt-1 text-gray-500 font-regular text-sm">
    {new Date(order.quotation_date).toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    })}
  </div>
)}

        </div>
      </div>

    <div className="flex items-center space-x-2 mb-4 ">
  {Array.isArray(order.items) && order.items.slice(0, 4).map((item, index) => (
    <div 
      key={item.item_id || index} 
      className="ml-3 relative w-14 h-14 rounded-md overflow-hidden bg-gray-100"
    >
                <img
                 src={
                   item.product_image
                     ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.product_image}`.trim()
                     : defaultimg
                 }
                 alt={item.product_name || `Product ${index + 1}`}
                 className="rounded-lg p-1 border border-gray-200 w-full h-full object-cover"
                 onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = defaultimg;
                 }}
               />
        
      
    </div>
  ))}
   
  {Array.isArray(order.items) && order.items.length > 4 && (
    <div className="w-12 h-12 bg-gray-50  rounded-md flex items-center justify-center text-xs font-bold text-gray-600 border border-gray-200">
      +{order.items.length - 4}
    </div>
  )}
</div>




      
    {/*   <div className="font-medium mt-3 flex justify-end text-sm">
        <button 
          onClick={() => navigate(`/supplier/orderdetails`, { 
            state: { quotationId: order._id , vendor_id : order.vendor_id} 
          })} 
          className='text-xs rounded-md py-1 px-3 bg-[#DE1B52] text-white'
        >
          View Order Details
        </button>
      </div> */}
      <div className='text-[#A8A1A1] px-4 py-3 border-t border-[#F8F2F2] flex flex-row justify-between items-start'>
        <svg
    width={20}
    height={20}
    viewBox="0 0 24 24"
   
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="5" r="2" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="12" cy="19" r="2" />
  </svg>
        <p>Rate us</p>
        <p>Payment Status</p>
      </div>
    </div>
  );
};

const Orders = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');
  const [orders , setOrders] = useState([]);
  const { notifications, setNotifications } = useNotification();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

   const [snackbarState, setSnackbarState] = useState({
      show: true,
      minimized: false
    });
     
    // Functions to control snackbar state
    const minimizeSnackbar = () => {
      setSnackbarState(prev => ({ ...prev, minimized: true }));
    };
    
    const expandSnackbar = () => {
      setSnackbarState(prev => ({ ...prev, minimized: false }));
    };
    
    const hideSnackbar = () => {
      setSnackbarState({ show: false, minimized: false });
    };

useEffect(() => {
    fetchQuotationsbyVendor();
  }, []);

  useEffect(() => {
  // Since all notifications are order-related, directly trigger refetch
  if (notifications && notifications.length > 0) {
    fetchQuotationsbyVendor();
  }
}, [notifications]);

 const fetchQuotationsbyVendor = async () => {
  try {
    setIsLoading(true);
    setError(null);
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      return;
    }
    
    const vendorData = JSON.parse(vendorDataString);
    console.log('Vendor Data:', vendorData);
    
    if (!vendorData || !vendorData.id) {
      console.error('Invalid vendor data or missing vendor ID');
      return;
    }
    
    const token = sessionStorage.getItem('token') || vendorData.token;
    
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/purchaseorder/get-supplier-orders?supplier_id=${vendorData.id}`, 
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    const data = await response.json();
    console.log('Quotations data:', data);
    
    if (data.success && Array.isArray(data.data)) {
      // Sort ALL data by date (latest first) - NO awardedOrders filter or reference
      const sortedData = data.data.sort((a, b) => {
        const dateA = new Date(a.order_date || a.createdAt || new Date());
        const dateB = new Date(b.order_date || b.createdAt || new Date());
        return dateB - dateA; // Latest first
      });
      
      const totalQuotations = sortedData.length;
      
      const formattedOrders = sortedData.map((quotation, index) => {
        const quotationDate = new Date(quotation.order_date || new Date());
        const now = new Date();
        const diffInDays = Math.floor((now - quotationDate) / (1000 * 60 * 60 * 24));
        const diffInMinutes = Math.floor((now - quotationDate) / (1000 * 60));
        
        let timeAgo;
        if (diffInDays > 0) {
          timeAgo = `${diffInDays}d ago`;
        } else if (diffInMinutes > 60) {
          timeAgo = `${Math.floor(diffInMinutes / 60)}h ago`;
        } else {
          timeAgo = `${diffInMinutes}min ago`;
        }
        
        const customerName = quotation.customer_name || 'Customer';
        const address = quotation.project_address || 'No address';
        
        const formattedDate = quotationDate.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
        
        const id = index + 1;
        
        return {
          id: id,
          _id: quotation._id,
          orderNumber: quotation.order_number,
          vendor_id: quotation.vendor_id,
          date: formattedDate,
          status: quotation?.status || '',
          vendor_status: quotation?.status || 'pending', // Maps to 'draft' for your data
          items: quotation.items || [],
          total: `₹${Math.round(quotation.total).toLocaleString("en-US")}`,
          customer: customerName,
          time: timeAgo,
          address: address,
          createdAt: quotation.createdAt,
          quotation_date: quotation.order_date,
          in_fulfillment_status: quotation.in_fulfillment_status || '', // Empty for your data
          order_waiting_time: quotation?.order_waiting_time || 10
        };
      });
      
      // Set ALL formatted orders (drafts included) - no awardedOrders reference
      setOrders(formattedOrders);
    } else {
      throw new Error('Failed to fetch quotations or invalid data format');
    }
  } catch (error) {
    console.error('Error fetching quotations:', error);
    setError(error.message);
    setOrders([]);
  } finally {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }
};


  // Filter orders based on active tab
 const filteredOrders = orders.filter(order => {
  if (activeTab === 'all') return true;
  
  const fulfillmentStatus = order.in_fulfillment_status?.toLowerCase() || '';
  
  if (activeTab === 'shipped') {
    return ['order items picked up', 'shipped'].includes(fulfillmentStatus.trim());
  }
  
  return false;
});

  const getStatusColor = (status) => {
    switch(status?.toLowerCase()) {
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'in progress': return 'bg-blue-100 text-blue-800';
      case 'completed': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="flex flex-col min-h-screen ">
    <div className="sticky top-0 z-50 flex flex-row items-center bg-white shadow-md px-1 h-14">

  {/* Back Button with Image */}
  <button onClick={() => navigate('/supplier/home')}>
    <img
      src={ArrowLeft}
      alt="Back"
      className="h-8 w-12 object-contain"
    />
  </button>

  {/* Title */}
  <p className="text-lg font-semibold text-gray-800">
    My Orders
  </p>

</div>
        
      {/* Conditional Rendering */}
      {isLoading ? (
        <OrdersSkeleton />
      ) : error ? (
        <div className="flex items-center justify-center min-h-[calc(100vh-100px)] text-center p-4">
          <div>
            <p className="text-red-500 text-lg mb-4">
              {error || 'An error occurred while fetching orders'}
            </p>
            <button 
              onClick={fetchQuotationsbyVendor}
              className="bg-[#F43042] text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
            >
              Retry
            </button>
          </div>
        </div>
      ) : (
        <div className='mb-4 p-4'>
            <div className="text-md flex flex-row justify-evenly mb-6">
        <button
          className={` px-2 font-medium ${activeTab === 'all' ? ' border-b-2 border-[#D93025]' : 'text-gray-500 hover:text-gray-700'}`}
          onClick={() => setActiveTab('all')}
        >
          All ({orders.length})
        </button>
      <button
  className={`px-2 font-medium ${activeTab === 'shipped' ? 'border-b-2 border-[#D93025]' : 'text-gray-500 hover:text-gray-700'}`}
  onClick={() => setActiveTab('shipped')}
>
  Shipped ({orders.filter(o => ['order items picked up', 'shipped'].includes(o.in_fulfillment_status?.toLowerCase() || '')).length})
</button>
      </div> 
      
        {/* Orders List */}
          <div className="space-y-4">
            {filteredOrders.length > 0 ? (
              filteredOrders.map(order => (
                <OrderCard 
                  key={order.id} 
                  order={order} 
                  navigate={navigate} 
                />
              ))
            ) : (
              <div className="flex flex-col items-center justify-center p-8 bg-white rounded-lg shadow-sm">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-20 w-20 text-gray-300 mb-4"
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M9 12l2 2 4-4M7 20l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" 
                  />
                </svg>
                <p className="text-gray-500 text-center">
                  No orders found 
                </p>
                <button 
                  onClick={fetchQuotationsbyVendor}
                  className="mt-4 bg-[#F43042] text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
                >
                  Refresh
                </button>
              </div>
            )}
          </div>
        </div>
      )}

   <Snackbar 
                snackbarState={snackbarState}
                notifications={notifications}
                minimizeSnackbar={minimizeSnackbar}
                expandSnackbar={expandSnackbar}
                hideSnackbar={hideSnackbar}
            /> 
    </div>
  );
};

export default Orders;
